interface TagListProps {
  tags: string[];
}

export default function TagList({ tags }: TagListProps) {
  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((tag, index) => (
        <span
          key={index}
          className="rounded-full bg-gray-10 px-[10px] py-[4px] text-[12px] font-bold leading-[1.5] text-gray-60"
        >
          {tag}
        </span>
      ))}
    </div>
  );
}
